/* @sravni/react-design-system version 0.2.71 */
import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import RowContext from './RowContext.js';
import modules_09e1f5ae from '../styles/Row.module.less.js';

/**
 * @description Container element for Grid system.
 *
 * @component
 * @example
 * ```jsx
 * <Row gutter={[20, 20]} wrap>
 *   ...columns
 * </Button>
 * ```
 */
var Row = React.forwardRef(function (props, ref) {
    var _a;
    var className = props.className, gutter = props.gutter, _b = props.align, align = _b === void 0 ? 'top' : _b, justify = props.justify, wrap = props.wrap, style = props.style, children = props.children, restProps = __rest(props, ["className", "gutter", "align", "justify", "wrap", "style", "children"]);
    var cx = useStyles(modules_09e1f5ae);
    var classNames = cx(className, 'container', (_a = {
            wrap: wrap
        },
        _a["align-".concat(align)] = align,
        _a["justify-".concat(justify)] = justify,
        _a));
    var gutters = React.useMemo(function () {
        var results = [0, 0];
        var normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, 0];
        normalizedGutter.forEach(function (g, index) {
            results[index] = g || 0;
        });
        return results;
    }, [gutter]);
    var rowStyle = __assign({}, style);
    var horizontalGutter = gutters[0] > 0 ? gutters[0] / -2 : undefined;
    if (horizontalGutter) {
        rowStyle.marginLeft = horizontalGutter;
        rowStyle.marginRight = horizontalGutter;
    }
    var rowContext = React.useMemo(function () { return ({ gutter: gutters, wrap: wrap }); }, [gutters, wrap]);
    return (React.createElement(RowContext.Provider, { value: rowContext },
        React.createElement("div", __assign({ "data-qa": "Row", ref: ref, className: classNames, style: __assign({}, rowStyle) }, restProps), children)));
});
Row.defaultProps = {
    gutter: 0,
    align: 'top',
    justify: 'start',
    wrap: true,
};
Row.displayName = 'Row';

export { Row };
//# sourceMappingURL=Row.js.map
